/* @flow */
import * as React from 'react';

import { SushiMapper } from './type';
import { thirdYearMapper } from './mappers';

export const SushiContext = React.createContext<SushiMapper>(thirdYearMapper);
